import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateSelectorWrapper, LabelStyled } from './styled';

export const DateSelectorPerDay = ({ startDate, endDate, setStartDate, setEndDate }) => {
  return (
    <DateSelectorWrapper>
      <LabelStyled>
       Data zgłoszenia od:
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="dd.MM.yyyy"
          placeholderText="Wybierz datę początkową"
        />
      </LabelStyled>
      <LabelStyled>
        Do:
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          dateFormat="dd.MM.yyyy"
          placeholderText="Wybierz datę końcową"
        />
      </LabelStyled>
    </DateSelectorWrapper>
  );
};
